import { render, staticRenderFns } from "./BestMatch.vue?vue&type=template&id=17591ab9&scoped=true&"
import script from "./BestMatch.vue?vue&type=script&lang=ts&"
export * from "./BestMatch.vue?vue&type=script&lang=ts&"
import style0 from "./BestMatch.vue?vue&type=style&index=0&id=17591ab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17591ab9",
  null
  
)

export default component.exports